export default __webpack_public_path__ + "static/1 Singing Mermaid-Little Angel Theatre-efe6cd5c94305de6344cc206681e2656.jpg";